import { pxToRem } from '@deltek/specification-client/core/Utilities/unitUtils'
import { makeStyles, Theme } from '@material-ui/core'
import { BulkAddBarStyleProps } from './BulkAddBar'

export const useBulkAddBarStyles = makeStyles((theme: Theme) => ({
    searchBarContainer: {
        position: 'absolute',
        top: (props: BulkAddBarStyleProps) =>
            props.isBetaWorkspaceToggleEnabled ? pxToRem(14) : pxToRem(17),
        backgroundColor: 'transparent',
    },
    searchFieldContainer: {
        width: '50%',
        height: pxToRem(35),
        marginLeft: theme.spacing(2.8),
        borderRadius: pxToRem(4),
        '@media (max-width: 1024px)': {
            width: '45%',
        },
    },
    closeIcon: (props: BulkAddBarStyleProps) => ({
        color: '#1d5f8c',
        fontSize: props.isBetaWorkspaceToggleEnabled
            ? pxToRem(24)
            : pxToRem(26),
        top: props.isBetaWorkspaceToggleEnabled ? 0 : pxToRem(0.5),
        position: 'absolute',
        cursor: 'pointer',
    }),
    elementTypeButton: {
        backgroundColor: (props: BulkAddBarStyleProps) =>
            props.isBetaWorkspaceToggleEnabled ? '#314959' : '#304959',
        color: theme.palette.common.white,
        borderRadius: pxToRem(100),
        padding: '6px 10px',
        '&:hover': {
            backgroundColor: '#091B32',
        },
        minWidth: pxToRem(127),
        '@media (max-width: 1200px)': {
            minWidth: 'unset',
        },
    },
    selectedElementsButton: {
        width: 228,
        height: 28,
        fontSize: pxToRem(12),
    },
    elementTypeItem: {
        borderRight: '1px solid #c9c9c9',
        '@media (max-width: 1024px)': {
            paddingLeft: theme.spacing(1.25),
        },
        paddingRight: (props: BulkAddBarStyleProps) =>
            props.isBetaWorkspaceToggleEnabled ? pxToRem(12) : pxToRem(20),
    },
    rightSideContents: {
        maxWidth: '40%',
        top: pxToRem(1),
        position: 'relative',
        right: pxToRem(8),
        '@media (max-width: 1024px)': {
            maxWidth: '50%',
        },
    },
    checkIcon: {
        color: '#33B55B',
    },
    elementTypeItems: {
        marginRight: theme.spacing(3),
    },
    confirmationText: (props: BulkAddBarStyleProps) => ({
        fontSize: props.isBetaWorkspaceToggleEnabled
            ? pxToRem(14)
            : pxToRem(18),
        color: props.isBetaWorkspaceToggleEnabled ? '#314959' : '#424242',
        fontWeight: 500,
        marginLeft: props.isBetaWorkspaceToggleEnabled
            ? pxToRem(12)
            : pxToRem(20),
        top: '0.5rem',
        position: 'absolute',
    }),
    startIcon: {
        fontSize: pxToRem(16) + '!important',
    },
}))
